<template>
    <gmap-circle v-if="position" :options="options" :center="position" :radius="radius"></gmap-circle>
</template>

<script>

export default {
  name: 'fox-circle',
  props: ['fox'],
  data() {
      return {
          radius: 0,
          options: {
            clickable: false,
        }
      }
  },
  mounted() {
      //this.setRadius();
      setInterval(() => {
          this.setRadius();
      }, 30000);
  },
  methods: {
      setRadius() {
          if(this.$store.getters[this.fox]) {
            var time = this.$store.getters[this.fox][0].time;
            var now = Date.now();
            var speed = 5000;
            var diff = now - time;
            
            this.radius = ((((diff / 1000) / 60) / 60) * speed)

            if(this.radius >= 10000)
                this.radius = 10000;
          }

            
      }
  },
  computed: {
    position() {
        var pos = this.$store.getters[this.fox][0];
        if(pos == undefined)
            return false;

        this.setRadius();
        return {lat: parseFloat(pos.lat), lng: parseFloat(pos.lng)};

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/maps/FoxCircle.vue